import { environment } from "src/environments/environment";

export class Utils {
  static readonly cardIdRegex = new RegExp('^[A-Z0-9]{16}$');
  static readonly pinRegex = new RegExp('^[0-9]{6}$');

  static get landingPageUrl(): string {
    return environment.production ? 'https://www.letscard.app' : 'https://dev.letscard.app';
  }
}